module.exports = __webpack_public_path__ + "static/img/noticia4.70b84b2b.jpeg";